import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TOrderReplicateService = {
  payload: {
    orderId: string
    clientsId: number | number[]
    replicaDesconto: boolean
    dispositivo: string
  }
}

export const orderReplicateService = async ({
  payload,
}: TOrderReplicateService): Promise<ResponseAPI> => {
  const response = await api.get(
    `/replicarpedido/${`${payload.dispositivo}/`}${payload.orderId}/${payload.clientsId}/${payload.replicaDesconto}`,
  )

  return response.data
}
